import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    bmCode: {
        name: () => '业务域',
    },

    fmCode: {
        name: () => '功能域',
    },

    independentUiFlag: {
        name: () => '是否独立界面',
    },

    layoutPicId: {
        name: () => '界面视图模板',
        hidden: (map, node) => ! node.data.layoutTypeCode,
    },

    layoutTypeCode: {
        name: () => '界面类型',
    },

    ssCode: {
        name: () => '子系统',
    },

    terminalType: {
        name: () => '终端类型',
    },

    uiPgCode: {
        name: () => '界面程序码',
    },

    uiUserCode: {
        name: () => '界面代码',
        required: () => true,
    },

    uiName: {
        name: () => '界面名称',
        required: () => true,
    },

    memo: {
        name: () => '备注',
    },

    vmCode: {
        name: () => '程序域',
    },
})
